export default __webpack_public_path__ + "static/media/mike-icon.7afbef32.svg";